import {
  cmdDeviceDesktop,
  cmdDeviceTablet,
  cmdDeviceMobile,
  cmdClear,
  cmdHelp,
  cmdSettings,
  cmdTools,
  cmdWebsite,
  cmdUpgrade,
  cmdPreview,
} from "./consts";

export default (editor, opts = {}) => {
  const pn = editor.Panels;
  const um = editor.UndoManager;
  const eConfig = editor.getConfig();
  const crc = "create-comp";
  const mvc = "move-comp";
  const swv = "sw-visibility";
  const expt = "export-template";
  const osm = "open-sm";
  const otm = "open-tm";
  const ola = "open-layers";
  const obl = "open-blocks";
  const ful = "fullscreen";
  const prv = "preview";

  eConfig.showDevices = 0;

  pn.getPanels().reset([
    {
      id: "commands",
      buttons: [{}],
    },
    {
      id: "options",
      buttons: [
        {
          id: "upgrade",
          className: "fa fa-arrow-up",
          label: "Upgrade",
          command: cmdUpgrade, // upgrade callback
          className: "gjs-btn-prim",
          attributes: {
            style: "font-size: 15px",
          },
        },
        {
          id: "help",
          className: "fa fa-question-circle-o",
          command: cmdHelp, // help callback
          attributes: {
            "data-tooltip-pos": "bottom",
            "data-tooltip": "Help",
            style: "border-left: 1px solid rgba(0,0,0,0.1)",
          },
        },
        {
          id: ful,
          command: ful,
          context: ful,
          label: `<svg width="1em" height="1em" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M1.464 10.536a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3.5a.5.5 0 0 1-.5-.5v-3.5a.5.5 0 0 1 .5-.5z"/><path fill-rule="evenodd" d="M5.964 10a.5.5 0 0 1 0 .707l-4.146 4.147a.5.5 0 0 1-.707-.708L5.257 10a.5.5 0 0 1 .707 0zm8.854-8.854a.5.5 0 0 1 0 .708L10.672 6a.5.5 0 0 1-.708-.707l4.147-4.147a.5.5 0 0 1 .707 0z"/><path fill-rule="evenodd" d="M10.5 1.5A.5.5 0 0 1 11 1h3.5a.5.5 0 0 1 .5.5V5a.5.5 0 0 1-1 0V2h-3a.5.5 0 0 1-.5-.5zm4 9a.5.5 0 0 0-.5.5v3h-3a.5.5 0 0 0 0 1h3.5a.5.5 0 0 0 .5-.5V11a.5.5 0 0 0-.5-.5z"/><path fill-rule="evenodd" d="M10 9.964a.5.5 0 0 0 0 .708l4.146 4.146a.5.5 0 0 0 .708-.707l-4.147-4.147a.5.5 0 0 0-.707 0zM1.182 1.146a.5.5 0 0 0 0 .708L5.328 6a.5.5 0 0 0 .708-.707L1.889 1.146a.5.5 0 0 0-.707 0z"/><path fill-rule="evenodd" d="M5.5 1.5A.5.5 0 0 0 5 1H1.5a.5.5 0 0 0-.5.5V5a.5.5 0 0 0 1 0V2h3a.5.5 0 0 0 .5-.5z"/></svg>`,
          attributes: {
            "data-tooltip-pos": "bottom",
            "data-tooltip": "Fullscreen",
          },
        },
        {
          id: cmdClear,
          className: "fa fa-trash-o",
          command: (e) => e.runCommand(cmdClear),
          attributes: {
            "data-tooltip-pos": "bottom",
            "data-tooltip": "Clear Canvas",
          },
        },
        {
          id: expt,
          className: "fa fa-code",
          command: (e) => e.runCommand(expt),
          attributes: {
            "data-tooltip-pos": "bottom",
            "data-tooltip": "Export",
          },
        },
        {
          id: "undo",
          label: `<svg width="1em" height="1em" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M6.104 2.396a.5.5 0 0 1 0 .708L3.457 5.75l2.647 2.646a.5.5 0 1 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 0 1 .708 0z"/><path fill-rule="evenodd" d="M2.75 5.75a.5.5 0 0 1 .5-.5h6.5a2.5 2.5 0 0 1 2.5 2.5v5.5a.5.5 0 0 1-1 0v-5.5a1.5 1.5 0 0 0-1.5-1.5h-6.5a.5.5 0 0 1-.5-.5z"/></svg>`,
          command: (e) => {
            um.hasUndo()
              ? undoBtn.set("attributes", {
                  style: "color: #66c9de",
                })
              : undoBtn.set("attributes", {
                  style: "color: inherit",
                });
            um.hasUndo() && e.runCommand("core:undo");
          },
          attributes: {
            "data-tooltip-pos": "bottom",
            "data-tooltip": "Undo",
          },
        },
        {
          id: "redo",
          label: `<svg width="1em" height="1em" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M9.896 2.396a.5.5 0 0 0 0 .708l2.647 2.646-2.647 2.646a.5.5 0 1 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 0 0-.708 0z"/><path fill-rule="evenodd" d="M13.25 5.75a.5.5 0 0 0-.5-.5h-6.5a2.5 2.5 0 0 0-2.5 2.5v5.5a.5.5 0 0 0 1 0v-5.5a1.5 1.5 0 0 1 1.5-1.5h6.5a.5.5 0 0 0 .5-.5z"/></svg>`,
          command: (e) => um.hasRedo() && e.runCommand("core:redo"),
          attributes: {
            "data-tooltip-pos": "bottom",
            "data-tooltip": "Redo",
          },
        },
        {
          attributes: {
            "data-tooltip-pos": "bottom",
            "data-tooltip": "Open Theme",
          },
          label: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-palette" viewBox="0 0 16 16">
                <path d="M8 5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zm4 3a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zM5.5 7a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm.5 6a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z"/>
                <path d="M16 8c0 3.15-1.866 2.585-3.567 2.07C11.42 9.763 10.465 9.473 10 10c-.603.683-.475 1.819-.351 2.92C9.826 14.495 9.996 16 8 16a8 8 0 1 1 8-8zm-8 7c.611 0 .654-.171.655-.176.078-.146.124-.464.07-1.119-.014-.168-.037-.37-.061-.591-.052-.464-.112-1.005-.118-1.462-.01-.707.083-1.61.704-2.314.369-.417.845-.578 1.272-.618.404-.038.812.026 1.16.104.343.077.702.186 1.025.284l.028.008c.346.105.658.199.953.266.653.148.904.083.991.024C14.717 9.38 15 9.161 15 8a7 7 0 1 0-7 7z"/>
                </svg>`,
          command: "open-update-theme",
          id: "open-theme",
        },
        {
          attributes: {
            "data-tooltip-pos": "bottom",
            "data-tooltip": "Project Manager",
          },
          label: `<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-folder" fill="currentColor">
                <path d="M9.828 4a3 3 0 0 1-2.12-.879l-.83-.828A1 1 0 0 0 6.173 2H2.5a1 1 0 0 0-1 .981L1.546 4h-1L.5 3a2 2 0 0 1 2-2h3.672a2 2 0 0 1 1.414.586l.828.828A2 2 0 0 0 9.828 3v1z"/>
                <path fill-rule="evenodd" d="M13.81 4H2.19a1 1 0 0 0-.996 1.09l.637 7a1 1 0 0 0 .995.91h10.348a1 1 0 0 0 .995-.91l.637-7A1 1 0 0 0 13.81 4zM2.19 3A2 2 0 0 0 .198 5.181l.637 7A2 2 0 0 0 2.826 14h10.348a2 2 0 0 0 1.991-1.819l.637-7A2 2 0 0 0 13.81 3H2.19z"/>
                </svg>`,
          command: "open-templates", //Open modal listing your pages
          id: "open-templates",
        },
        {
          attributes: {
            "data-tooltip-pos": "bottom",
            "data-tooltip": "Clone Page",
          },
          label: `<svg width="16" height="16" fill="currentColor" viewBox="0 0 16 16"><path d="M13 0H6a2 2 0 0 0-2 2 2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h7a2 2 0 0 0 2-2 2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zm0 13V4a2 2 0 0 0-2-2H5a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1zM3 4a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4z"/></svg>`,
          command: "clone-page",
          id: "clone-page",
        },
        {
          id: prv,
          context: prv,
          command: cmdPreview,
          className: "fa fa-eye",
          attributes: {
            "data-tooltip-pos": "bottom",
            "data-tooltip": "Preview",
            style: "border-right: 1px solid rgba(0,0,0,0.1)",
          },
        },
        {
          id: "save",
          command: (e) => opts.onSave(e),
          label: "Save",
          className: "gjs-btn-prim-o",
          attributes: {
            style: "font-size: 15px",
          },
        },
        {
          id: "publish",
          command: (e) => opts.onPublish(e),
          label: '<i class="fa fa-paper-plane-o"></i> Publish',
          className: "gjs-btn-prim",
          attributes: {
            style: "font-size: 15px",
          },
        },
      ],
    },
    {
      id: "views",
      buttons: [
        {
          id: otm,
          command: otm,
          label: "Content",
          togglable: false,
          //className: 'fa fa-cog',
        },
        {
          id: osm,
          command: osm,
          active: true,
          label: "Design",
          togglable: false,
          //className: 'fa fa-paint-brush',
        },
        {
          id: ola,
          command: ola,
          label: "Layers",
          togglable: false,
          //className: 'fa fa-bars',
        },
      ], //Dropped Blocks
    },
  ]);

  // Add devices buttons
  const panelDevices = pn.addPanel({
    id: "devices",
  }); //previous id devices-c
  panelDevices.get("buttons").add([
    {
      id: "logo",
      command: (e) => e,
      context: "logo",
      attributes: {
        style: "padding:5px;margin-right:0",
      },
      label:
        `<img class="gjs-logo" src="${opts.logo}" style="height: 100%;">`,
    },
    {
      id: cmdDeviceDesktop,
      command: cmdDeviceDesktop,
      label: `<svg width="1em" height="1em" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M13.5 3h-11a.5.5 0 0 0-.5.5V11h12V3.5a.5.5 0 0 0-.5-.5zm-11-1A1.5 1.5 0 0 0 1 3.5V12h14V3.5A1.5 1.5 0 0 0 13.5 2h-11z"/><path d="M0 12h16v.5a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 12.5V12z"/></svg>`,
      attributes: {
        "data-tooltip-pos": "bottom",
        "data-tooltip": "Desktop",
        style: "border-left: 1px solid rgba(0,0,0,0.1)",
      },
      togglable: 0,
      active: 1,
    },
    {
      id: cmdDeviceTablet,
      command: cmdDeviceTablet,
      label: `<svg width="1em" height="1em" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M12 1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1zM4 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H4z"/><path fill-rule="evenodd" d="M8 14a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"/></svg>`,
      attributes: {
        "data-tooltip-pos": "bottom",
        "data-tooltip": "Tablet",
      },
      togglable: 0,
    },
    {
      id: cmdDeviceMobile,
      command: cmdDeviceMobile,
      label: `<svg width="1em" height="1em" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M11 1H5a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1zM5 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H5z"/><path fill-rule="evenodd" d="M8 14a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"/></svg>`,
      attributes: {
        "data-tooltip-pos": "bottom",
        "data-tooltip": "Mobile",
        style: "border-right: 1px solid rgba(0,0,0,0.1);font-size:15px;",
      },
      togglable: 0,
    },
    {
      id: "website",
      label: "Website",
      context: "website",
      command: cmdWebsite, // open website
      attributes: {
        style: "border-right: 1px solid rgba(0,0,0,0.1);font-size:15px;",
      },
    },
    {
      id: "settings",
      label: "Settings",
      context: "settings",
      command: cmdSettings, // open settings
      attributes: {
        style: "border-right: 1px solid rgba(0,0,0,0.1);font-size:15px;",
      },
    },
    {
      id: "tools",
      label: "Tools",
      context: "tools",
      command: cmdTools, // open tools
      attributes: {
        style: "border-right: 1px solid rgba(0,0,0,0.1);font-size:15px;",
      },
    },
  ]);

  const undoBtn = pn.getButton("options", "undo");
  const redoBtn = pn.getButton("options", "redo");
  const saveBtn = pn.getButton("options", "save");

  editor.on("change:changesCount", () => {
    um.hasUndo()
      ? undoBtn.set("attributes", {
          style: "color: #66c9de",
        })
      : undoBtn.set("attributes", {
          style: "color: inherit",
        });
    um.hasRedo()
      ? redoBtn.set("attributes", {
          style: "color: #66c9de",
        })
      : redoBtn.set("attributes", {
          style: "color: inherit",
        });
    editor.getDirtyCount() > 0
      ? saveBtn.set("className", "gjs-btn-prim-o glow")
      : saveBtn.set("className", "gjs-btn-prim-o");
  });
};
